import React, { Component } from 'react';
import { connect } from 'react-redux'

import CompaniesTable from './CompaniesTable';
import companyServices from '../../api/companiesService';
import CompanyForm from './CompanyForm';

class CompaniesScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            showDeleteConfirmation: false,
            loadingData: true
        }

        this.showForm = this.showForm.bind(this);
        this.hideForm = this.hideForm.bind(this);
    }

    showForm() {
        this.setState({
            showForm: true
        });
    }

    hideForm() {
        this.setState({
            showForm: false
        });
    }

    showDeleteConfirmation() {
        this.setState({
            showDeleteConfirmation: true
        });
    }

    hideDeleteConfirmation() {
        this.setState({
            showDeleteConfirmation: false
        });
    }

    render() {
        return (
            <div>
                <CompaniesTable companies={this.props.companies}
                    addCompany={this.showForm}
                    deleteCompany={this.showDeleteConfirmation} />
                <CompanyForm showModal={this.state.showForm} hideForm={this.hideForm} />
            </div>
        )
    }
}

const mapStateToProps = ({ companyState }) => ({
    companies: companyState.companies
});

export default connect(mapStateToProps)(CompaniesScreen);